import CONSTANTES from '../constantes'

const initialState = {
	detailProduct: null,
	entities: [],
	total: 0,
	searchText: '',
	routeParams: {},
	productModal: {
		type: 'new',
		props: {
			visible: false
		},
		data: null
	},
	configTarifas: null
};

export const reducerProductos = (state = initialState, action) => {
	switch (action.type) {
		case CONSTANTES.GET_PRODUCTS_SUCCESS:
			return {
				...state,
				entities: [...action.payload],
				total: action.total
			};
		case CONSTANTES.GET_PRODUCTS_DETAIL_SUCCESS:
			return {
				...state,
				detailProduct: { ...action.payload }
			};
		case CONSTANTES.ADD_PRODUCT_SUCCESS:
			return {
				...state,
				entities: [action.payload, ...state.entities]
			};
		case CONSTANTES.UPDATE_PRODUCT_SUCCESS:
			return {
				...state,
				entities: state.entities.map(item => {
					if (item.id === action.product.id) {
						return { ...item, ...action.product };
					}
					return item;
				})
			};
		case CONSTANTES.OPEN_NEW_MODAL_PRODUCT: {
			return {
				...state,
				productModal: {
					type: 'new',
					props: {
						visible: true
					},
					data: null
				}
			};}
		case CONSTANTES.CLOSE_NEW_MODAL_PRODUCT: {
			return {
				...state,
				productModal: {
					type: 'new',
					props: {
						visible: false
					},
					data: null
				}
			};
		}
		case CONSTANTES.OPEN_EDIT_MODAL_PRODUCT: {
			return {
				...state,
				productModal: {
					type: 'edit',
					props: {
						visible: true
					},
					data: action.data
				}
			};
		}
		case CONSTANTES.CLOSE_EDIT_MODAL_PRODUCT: {
			return {
				...state,
				productModal: {
					type: 'edit',
					props: {
						visible: false
					},
					data: null
				}
			};
		}
		case CONSTANTES.GET_CONFIG_TARIFAS_SUCCESS:
			return {
				...state,
				configTarifas: { ...action.data }
			};
		case CONSTANTES.EDIT_TARIFAS_REQUEST_SUCCESS:
			return {
				...state,
				configTarifas: { ...action.data }
			};

		default: {
			return state;
		}
	}
};


const initialStateFiles = {
	filesProduct: [],
}

export const reducerFileProduct = (state = initialStateFiles, action) => {
	switch (action.type) {
		case CONSTANTES.GET_FILES_PRODUCTS_SUCCESS:
			return {
				...state,
				filesProduct: [...action.files],
			};
		case CONSTANTES.ADD_PRODUCT_FILE_SUCCESS:
			return {
				...state,
				filesProduct: [...state.filesProduct, action.newFile,]
			};
		case CONSTANTES.EDIT_PRODUCT_FILE_SUCCESS:
			return {
				...state,
				filesProduct: state.filesProduct.map(item => {
					if (item.id === action.fileObject.id) {
						return { ...item, ...action.fileObject };
					}
					return item;
				})
			};
		case CONSTANTES.DELETE_PRODUCT_FILE_REQUEST:
			const indexFile=state.filesProduct.findIndex(item=> item.uid===action.file.uid)
			return {
				...state,
				filesProduct: [...state.filesProduct.slice(0,indexFile), ...state.filesProduct.slice(indexFile+1)]
			};
		default: {
			return state;
		}
	}
}